var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 10C19.4477 10 19 10.4477 19 11V12C19 15.8658 15.8657 19 12 19C8.13431 19 4.99997 15.8658 4.99997 12V11C4.99997 10.4478 4.55227 10 3.99998 10C3.4477 10 3 10.4478 3 11V12C3 16.6323 6.50034 20.4468 11 20.9444V22H8.99995C8.44767 22 7.99997 22.4477 7.99997 23C7.99997 23.5523 8.44767 24 8.99995 24H15C15.5522 24 15.9999 23.5523 15.9999 23C15.9999 22.4477 15.5522 22 15 22H12.9999V20.9445C17.4996 20.4468 21 16.6323 21 12V11C21 10.4478 20.5522 10 20 10Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 18C15.3133 18 18 15.3133 18 12V6C18 2.68673 15.3133 0 12 0C8.68673 0 6 2.68673 6 6V12C6 15.3133 8.68673 18 12 18ZM8.00002 6C8.00002 3.7913 9.7913 2.00002 12 2.00002C14.2087 2.00002 16 3.7913 16 6V12C16 14.2087 14.2087 16 12 16C9.7913 16 8.00002 14.2087 8.00002 12V6Z",
    fill: "#808080"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.9bc795ecaa5339e1aa409afd8c986f11.svg";
export { ForwardRef as ReactComponent };